// extracted by mini-css-extract-plugin
export default {"formContentLeft":"Success_formContentLeft__y5X8C","formImg2":"Success_formImg2__aYG9j","formHeader":"Success_formHeader__wzCLH","formDesc":"Success_formDesc__f-iAi"};